<script lang="ts" setup>
import { toTypedSchema } from "@vee-validate/valibot"
import * as v from "valibot"
import { useForm } from "vee-validate"

const { loading } = defineProps<{
	loading: boolean
}>()

const emit = defineEmits<{
	submit: [values: string]
}>()

const phoneNumber = defineModel<string>()

const form = useForm({
	validationSchema: toTypedSchema(
		v.object({
			phone: PhoneNumberValidator,
		}),
	),
})

watchEffect(() => {
	form.setValues({ phone: phoneNumber.value })
})

const onSubmit = form.handleSubmit((values) => {
	if (loading)
		return
	phoneNumber.value = values.phone
	emit("submit", values.phone)
})
</script>

<template>
	<LoginContainer>
		<div class="flex flex-col items-center justify-center gap-y-3 text-center">
			<div class="flex gap-x-1 text-center text-xl text-[#181E25] md:text-2xl">
				شماره تلفن همراهتو وارد کن
			</div>

			<div class="text-center text-xs md:text-sm">
				کد یک بار مصرف ورود به شماره همراهت پیامک میشه.
			</div>
		</div>

		<NuxtImg
			src="/images/phone_image.png"
			width="340"
			format="webp"
			height="340" />

		<form
			class="grid w-full gap-3 px-4"
			@submit="onSubmit">
			<UFormField
				v-slot="{ componentField }"
				name="phone">
				<UFormItem>
					<UFormControl>
						<PhoneInput
							v-bind="componentField"
							placeholder="شماره تماس (09123456789)">
							<template #prepend>
								<Icon
									name="i-fa6-solid:phone"
									class="block bg-[#00A0ED]" />
							</template>
						</PhoneInput>
					</UFormControl>

					<UFormDescription />

					<UFormMessage />
				</UFormItem>
			</UFormField>

			<Btn
				:disabled="loading"
				type="submit"
				class="w-full bg-primary px-4 py-2 hover:bg-primary/75">
				<div class="w-full text-center text-primary-foreground">
					<FadeTransition>
						<div v-if="!loading">
							ارسال کد
						</div>

						<Icon
							v-else
							class="size-5"
							name="i-svg-spinners:180-ring-with-bg" />
					</FadeTransition>
				</div>
			</Btn>
		</form>
	</LoginContainer>
</template>
